<template>
  <div class="height1">
    <!--      头部      -->
    <bread></bread>
    <!--    内容    -->
    <div class="center-content">
      <div class="iq-card-body">
        <div class="table-top">
          <div class="iq-search-bar">
            <el-form :model="searchForm" :inline="true">
              <el-form-item>
                <el-date-picker v-model="searchForm.datepicker" type="month" placeholder="选择月份" format="yyyy年MM月" value-format="yyyy-MM" style="margin-right: 10px" size="small" @change="search" :clearable="false" />
              </el-form-item>
              <el-form-item label="部门">
                <el-cascader :options="DepartmentData" :props="{ expandTrigger: 'hover', checkStrictly: true, value: 'id', label: 'name', children: 'childrens' }" :clearable="true" style="width: 100%" filterable @change="handleChange" size="small"></el-cascader>
              </el-form-item>
              <el-form-item>
                <el-input v-model="searchForm.keyWord" type="text" size="small" placeholder="姓名" @keyup.enter.native="search" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="search()">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <div class="flex-start">
                  <div class="bg1"></div>
                  <div>上午 08:00~12:00</div>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="flex-start">
                  <div class="bg2"></div>
                  <div>下午 14:00~18:00</div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 主体表格 -->
        <div class="table-wrapper" ref="tableWrapper">
          <!-- 左侧固定列 -->
          <div class="fixed-column scrollable-hidden" ref="fixedColumn" @scroll.passive="handleFixedScroll">
            <table>
              <thead>
                <tr>
                  <th class="fixed-header">医生|日期</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="doctor in visibleDoctors" :key="doctor.id" class="doctor-row">
                  <td class="fixed-cell">
                    <img class="note-logo" :src="`${CommonPath}${doctor.photoFile}`" v-if="doctor.photoFile" />
                    <img class="note-logo" src="@/assets/img/touxiang03.png" v-else />
                    <div class="doctor-name oneLine">{{ doctor.userName }}</div>
                    <div class="doctor-name oneLine" style="font-size: 10px">{{ doctor.departmentName }}</div>
                    <el-tooltip class="item" effect="dark" content="复制本月排班" placement="right-start">
                      <img src="@/assets/img/jg_copy.png" alt="复制本月排班" style="position: absolute; top: 5px; right: 5px; font-size: 10px; cursor: pointer; width: 15px; height: 16px" @click="copeSchedules(doctor)" />
                      <!-- <el-tag type="danger" size="mini" @click="copeSchedules(doctor)">复制</el-tag> -->
                    </el-tooltip>
                  </td>
                </tr>
                <tr v-if="loading">
                  <td class="loading-cell">
                    <el-icon class="is-loading"><Loading /></el-icon>
                    加载中...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- 右侧可滚动内容 -->
          <div class="scrollable-content scrollable-hidden" ref="scrollableContent" @scroll.passive="handleContentScroll" @mousedown="startDrag" @mousemove="handleDrag" @mouseup="endDrag" @mouseleave="endDrag">
            <table>
              <thead>
                <tr>
                  <th v-for="day in monthDays" :key="day.date" class="day-header">
                    <div>{{ formatDay(day.date) }}</div>
                    <div>{{ formatWeekday(day.date) }}</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="doctor in visibleDoctors" :key="doctor.id" class="doctor-row">
                  <td v-for="day in monthDays" :key="day.date" class="day-cell">
                    <div class="cell-content schedule-disabled flex-sa-column" v-if="day.state == 0">
                      <div class="flex-sb-column" style="width: 100%; height: 100%" v-if="doctor.schedules[day.date] && doctor.schedules[day.date].data">
                        <div style="width: 100%">
                          <div v-for="(dayData, i) in doctor.schedules[day.date].data" :key="i" style="width: 100%; margin-bottom: 5px">
                            <div class="t1 desc-disabled flex-space-between">
                              <div class="line1"></div>
                              <div class="flex-space-between" style="width: calc(100% - 2px)">
                                <div class="t2">● {{ dayData.timePeriod == 1 ? "上午" : "下午" }}</div>
                                <div>{{ `${dayData?.currentAppointmentCount}/${dayData?.quantity}个` }}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="t1 flex-space-between">
                          <div>{{ `已约 ${doctor.schedules[day.date].data[0]?.currentAppointmentCount + doctor.schedules[day.date].data[1]?.currentAppointmentCount || 0} 个` }}</div>
                          <!-- <div>修改</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="cell-content schedule-available flex-sa-column" @click="handleCellClick(doctor, day.date)" v-else>
                      <div class="flex-sb-column" style="width: 100%; height: 100%" v-if="doctor.schedules[day.date] && doctor.schedules[day.date].data">
                        <div style="width: 100%">
                          <div v-for="(dayData, i) in doctor.schedules[day.date].data" :key="i" style="margin-bottom: 5px">
                            <div class="t1 desc-disabled flex-space-between" :class="dayData.timePeriod == 1 ? 'desc-available1' : 'desc-available2'">
                              <div class="" :class="dayData.timePeriod == 1 ? 'line2' : 'line3'"></div>
                              <div class="flex-space-between" style="width: calc(100% - 2px)">
                                <div class="t2">● {{ dayData.timePeriod == 1 ? "上午" : "下午" }}</div>
                                <div>{{ `${dayData?.currentAppointmentCount}/${dayData?.quantity}个` }}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="t3 flex-space-between">
                          <div style="color: #0086cb">{{ `已约 ${doctor.schedules[day.date].data[0]?.currentAppointmentCount + doctor.schedules[day.date].data[1]?.currentAppointmentCount || 0} 个` }}</div>
                          <div class="flex-end">
                            <div style="color: #5c955c" @click.stop="copySchedule(doctor, day.date)">复制</div>
                            <div style="color: #ff4949;margin-left: 5px">修改</div>
                            <div style="color: #0086cb; margin-left: 5px" @click.stop="delSchedule(doctor, day.date)">删除</div>
                          </div>
                        </div>
                      </div>
                      <div class="flex-center-c" style="width: 100%; height: 100%" v-else>
                        <img class="" style="width: 30px; height: 30px" src="@/assets/img/pb_plus.png" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="loading">
                  <td :colspan="monthDays.length" class="loading-cell">
                    <el-icon class="is-loading"><Loading /></el-icon>
                    加载中...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- 排班设置弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible">
      <el-form :model="tempSchedule" label-width="20px" :rules="rules">
        <h4>1、设置班次、放号数量、金额</h4>
        <div>
          <div class="flex-start" v-for="(item, index) in tempSchedule.timeArray" :key="index" style="margin-top: 10px; margin-bottom: -10px">
            <el-form-item label="" style="width: 150px">
              <el-checkbox v-model="item.isHave" @change="handelChange($event, index)">{{ item.startTime }} ~ {{ item.endTime }}</el-checkbox>
            </el-form-item>
            <el-form-item label="">
              <el-input-number v-model="item.quantity" controls-position="right" size="mini" :min="0" :disabled="!item.isHave" />
              <span class="schedule-remain" style="margin-right: 10px"> 个</span>
            </el-form-item>
            <el-form-item label="">
              <el-input-number v-model="item.price" controls-position="right" size="mini" :min="0" :precision="2" :disabled="!item.isHave" />
              <span class="schedule-remain"> 元/个</span>
            </el-form-item>
          </div>
        </div>
        <template v-if="tempSchedule.mark == 'add'">
          <h4 style="margin-top: 10px">2、班次重复设置</h4>
          <el-form-item label="">
            <el-radio-group v-model="tempSchedule.scheduleMode">
              <el-radio :label="0">不重复</el-radio>
              <el-radio :label="1">每周重复</el-radio>
              <!-- <el-radio :label="2">每月重复</el-radio> -->
            </el-radio-group>
          </el-form-item>
        </template>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button @click="rest">重置</el-button>
        <el-button type="primary" @click="saveSchedule">保存</el-button>
      </template>
    </el-dialog>
    <el-dialog title="复制排班" :visible.sync="dialogCope" width="30%">
      <el-form :model="copeForm" ref="copeForm" label-width="200px" :rules="rules">
        <el-form-item label="请选择目标月份" prop="destDate">
          <el-date-picker v-model="copeForm.destDate" type="month" placeholder="选择月份" format="yyyy年MM月" value-format="yyyy-MM" style="margin-right: 10px" size="small" :picker-options="pickerOptions0" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogCope = false">取消</el-button>
        <el-button type="primary" @click="saveCopeSchedule('copeForm')">保存</el-button>
      </template>
    </el-dialog>
    <el-dialog title="复制排班" :visible.sync="dialogCopeToday" width="30%">
      <el-form :model="copeFormToday" ref="copeFormToday" :rules="rules">
        <el-form-item label="请选择目标日期" prop="destDateList">
          <el-date-picker v-model="copeFormToday.destDateList" type="dates" placeholder="选择一个或多个日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" style="margin-right: 10px" size="small" :picker-options="pickerOption" />
        </el-form-item>
        <el-tag v-for="(item,index) in copeFormToday.destDateList" :key="index" type="success" style="margin-right:10px">{{item}}</el-tag>
      </el-form>
      <template #footer>
        <el-button @click="dialogCopeToday = false">取消</el-button>
        <el-button type="primary" @click="saveCopeScheduleToday('copeFormToday')">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import bread from "../../../components/common/breadcrumb";
import { Organization } from "../../../components/HospitalDomain/Organization";
import { User } from "../../../components/HospitalDomain/User";
import { DoctorAppointment } from "../../../components/DrugDomain/DoctorAppointment.js";

export default {
  components: { Loading, bread },
  data() {
    const currentDate = new Date();
    const currentMonth = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}`;

    var organization = new Organization(this.TokenClient, this.Services.Authorization);
    var user = new User(this.TokenClient, this.Services.Authorization);
    var doctorAppointment = new DoctorAppointment(this.TokenClient, this.Services.Drug);
    return {
      DoctorAppointment: doctorAppointment,
      Organization: organization,
      User: user,
      organizationId: JSON.parse(sessionStorage.getItem("userInfo")).organizationId,
      searchForm: {
        keyWord: "",
        departmentId: 0,
        datepicker: currentMonth,
      },
      rules: {
        malfunctionMessage: [{ required: true, message: "请输入内容", trigger: "blur" }],
        name: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
        destDate: [{ required: true, message: "请选择月份", trigger: "change" }],
        quantity: [{ required: true, message: "请设置放号数量大于0", trigger: "blur" }],
        price: [{ required: true, message: "金额必须大于0", trigger: "blur" }],
      },
      pickerOptions0: {
        disabledDate: (time) => {
          if (!this.searchForm.datepicker) return false;
          const cutoffDate = new Date(this.searchForm.datepicker);
          console.log(this.getMonthStartTime(cutoffDate));
          return time.getTime() < this.getMonthStartTime(cutoffDate);
        },
      },
      pickerOption:{
        disabledDate: (time) => {
          return time.getTime() < Date.now();
        },
      },
      dialogCope: false,
      copeForm: {
        doctorId: 0,
        sourceDate: null,
        destDate: null,
      },
      copeFormToday:{
        doctorId: 0,
        sourceDate: null,
        destDateList: null,
      },
      DepartmentData: [],
      currentMonth: currentMonth,
      currentDept: "",
      departments: [
        { id: "1", name: "内科" },
        { id: "2", name: "外科" },
        { id: "3", name: "儿科" },
        { id: "4", name: "妇产科" },
      ],
      allDoctors: [],
      visibleDoctors: [],
      monthDays: [],
      weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      weekNumdays: [0, 1, 2, 3, 4, 5, 6],
      loading: false,
      PageIndex: 1,
      PageTotal: 1,
      PageSize: 15,
      dataTotal: 0,
      dialogVisible: false,
      dialogTitle: "",
      tempSchedule: {
        doctorId: 0,
        doctorName: "",
        doctorPhone: "",
        scheduleMode: null,
        appointmentDetailList: null,
        dateMonth: null,
        doctor: null,
        date: null,
        dataTag: {
          am: false,
          amQuantity: 0,
          amPrice: 0,
          pm: false,
          pmQuantity: 0,
          pmPrice: 0,
        },
      },
      // 拖拽相关状态
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      // 滚动同步控制
      scrollSync: true,
      dialogCopeToday:false
    };
  },
  computed: {
    totalDoctors() {
      return this.allDoctors.length;
    },
  },
  mounted() {
    this.InitialDepartment();
  },
  methods: {
    getMonthStartTime(date) {
      return new Date(date.getFullYear(), date.getMonth() + 1, 1).getTime();
    },
    copeSchedules(doctor) {
      this.copeForm = {
        doctorId: doctor.id,
        sourceDate: this.searchForm.datepicker,
        destDate: null,
      };
      this.dialogCope = true;
    },
    copySchedule(doctor,date){
      var _this = this
      _this.copeFormToday = {
        doctorId: doctor.id,
        sourceDate: date,
        destDateList: null,
      };
      _this.dialogCopeToday = true
    },
    saveCopeScheduleToday(){
      const _this = this;
      if (!_this.copeFormToday.destDateList) {
        _this.$message({
          type: "warning",
          message: "请选择目标日期！",
        });
        return;
      }
      _this.DoctorAppointment.CopyDoctorAppointmentScheduleToOtherDay(
        _this.copeFormToday,
        function (data) {
           _this.$message.success("排班设置已保存");
          _this.allDoctors = [];
          _this.dialogCopeToday = false
          _this.loadDoctors();
        },
        function (err) {
          _this.dialogCopeToday = false
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    saveCopeSchedule(doctor, date) {
      const _this = this;
      if (!this.copeForm.destDate) {
        _this.$message({
          type: "warning",
          message: "请选择目标月份！",
        });
        return;
      }
      _this.DoctorAppointment.CopyDoctorAppointmentSchedule(
        this.copeForm.doctorId,
        this.copeForm.sourceDate,
        this.copeForm.destDate,
        function (data) {
          _this.$message.success("排班设置已保存");
          _this.dialogCope = false;
          _this.allDoctors = [];
          _this.loadDoctors();
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    handleOption(e) {
      this.searchForm.departmentId = e[e.length - 1];
      this.PageIndex = 1;
      // this.InitialUser()
    },
    InitialDepartment() {
      var _this = this;
      _this.Organization.DepartmentTree(
        _this.organizationId,
        false,
        function (data) {
          _this.DepartmentData = data.data;
          _this.loadDoctors();
        },
        function (err) {
          console.log(err);
        }
      );
    },
    search() {
      this.allDoctors = [];
      this.PageIndex = 1;
      this.loadDoctors();
    },
    handleChange(e) {
      this.searchForm.departmentId = e[e.length - 1];
      console.log(this.searchForm.departmentId);
      this.allDoctors = [];
      this.PageIndex = 1;
      this.loadDoctors();
    },
    generateMonthDays() {
      return new Promise((resolve, reject) => {
        const date = new Date();
        const monthNow = date.getMonth() + 1;
        const dayNow = date.getDate();
        const yearNow = date.getFullYear();
        const [year, month] = this.searchForm.datepicker.split("-");
        const daysInMonth = new Date(year, month, 0).getDate();
        const days = [];
        this.monthDays = Array.from({ length: daysInMonth }, (_, i) => {
          const date = new Date(year, month - 1, i + 2);
          let state = 0;
          if (month == monthNow) {
            state = i < dayNow ? 0 : 1;
          } else if (month > monthNow || year > yearNow) {
            state = 1;
          } 
          return {
            date: date.toISOString().split("T")[0],
            day: i,
            weekday: date.getDay(),
            state: state, //是否可设置，今天之后可设置
            weekdayName: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"][date.getDay()],
          };
        });
        resolve(true);
      });
    },
    async loadDoctors() {
      var _this = this;
      this.loading = true;

      if (await this.generateMonthDays()) {
        let newDoctors = [];
        _this.User.GetAppointmentDoctorAndSchedulePage(
          this.searchForm.datepicker,
          this.searchForm.departmentId ? this.searchForm.departmentId : 0,
          this.searchForm.keyWord,
          this.PageIndex,
          this.PageSize,
          function (data) {
            newDoctors = data.data.results;
            _this.PageIndex = data.data.pageIndex;
            _this.PageSize = data.data.pageSize;
            _this.PageTotal = data.data.pageCount;
            _this.dataTotal = data.data.dataTotal;
            newDoctors.forEach((item, i) => {
              item.schedules = _this.monthDays.reduce((acc, day) => {
                let schedulesArray = item.schedules[day.date];
                if (schedulesArray && schedulesArray.length > 0) {
                  acc[day.date] = {
                    data: schedulesArray,
                  };
                } else {
                  acc[day.date] = {
                    data: null,
                  };
                }
                return acc;
              }, {});
            });
            _this.allDoctors = [..._this.allDoctors, ...newDoctors];
            _this.updateVisibleDoctors();
            _this.loading = false;
          },
          function (error) {
            console.log(error);
          }
        );
      }
    },
    updateVisibleDoctors() {
      this.visibleDoctors = this.allDoctors.slice(0, this.PageIndex * this.PageSize);
    },
    formatWeekday(date) {
      const d = new Date(date);
      return this.weekdays[d.getDay()];
    },
    formatWeekdayNum(date) {
      const d = new Date(date);
      return this.weekNumdays[d.getDay()];
    },
    formatDay(date) {
      const d = new Date(date);
      return d.getDate();
    },
    formatDateMonth(date) {
      const d = new Date(date);
      return `${d.getFullYear()}${d.getMonth() + 1}`;
    },
    formatFullDate(date) {
      const d = new Date(date);
      return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
    },
    getScheduleDisplay(schedule, type) {
      if (!schedule) return "";
      let str = "";
      // const amRemain = schedule.amTotal - schedule.amBooked;
      // const pmRemain = schedule.pmTotal - schedule.pmBooked;
      if (type == "am") {
        str = `${schedule?.amBooked}/${schedule?.amTotal}个 ￥${schedule?.amMoney?.toFixed(2)}`;
      }
      if (type == "pm") {
        str = `${schedule?.pmBooked}/${schedule?.pmTotal} ￥${schedule?.pmMoney?.toFixed(2)}`;
      }
      if (type == "total") {
        str = `已约 ${schedule?.amBooked + schedule?.pmBooked}个`;
      }
      return `${str}`;
    },
    getCellClass(doctor, date) {
      const schedule = doctor.schedules[date];

      const amAvailable = schedule.amTotal - schedule.amBooked > 0;
      const pmAvailable = schedule.pmTotal - schedule.pmBooked > 0;

      if (amAvailable && pmAvailable) return "schedule-available";
      if (amAvailable || pmAvailable) return "schedule-partial";
      return "schedule-full";
    },
    rest() {
      this.initTimeArray();
      this.tempSchedule.scheduleMode = 0;
    },
    initTimeArray(schedule) {
      this.tempSchedule.timeArray = [];
      for (let index = 0; index < 8; index++) {
        let isHave = false;
        let quantity = null;
        let price = null;
        let startTime = "";
        let endTime = "";
        let timePeriod = 0;
        switch (index) {
          case 0:
            startTime = "08:00";
            endTime = "09:00";
            timePeriod = 1;
            break;
          case 1:
            startTime = "09:00";
            endTime = "10:00";
            timePeriod = 1;
            break;
          case 2:
            startTime = "10:00";
            endTime = "11:00";
            timePeriod = 1;
            break;
          case 3:
            startTime = "11:00";
            endTime = "12:00";
            timePeriod = 1;
            break;
          case 4:
            startTime = "14:00";
            endTime = "15:00";
            timePeriod = 2;
            break;
          case 5:
            startTime = "15:00";
            endTime = "16:00";
            timePeriod = 2;
            break;
          case 6:
            startTime = "16:00";
            endTime = "17:00";
            timePeriod = 2;
            break;
          case 7:
            startTime = "17:00";
            endTime = "18:00";
            timePeriod = 2;
            break;
        }
        if (schedule && schedule.length > 0) {
          let res = schedule.filter((i) => i.startTime == startTime);
          if (res && res.length > 0) {
            isHave = true;
            quantity = res[0].quantity;
            price = res[0].price;
          }
        }
        this.tempSchedule.timeArray.push({
          isHave: isHave,
          timePeriod: timePeriod,
          startTime: startTime,
          endTime: endTime,
          quantity: quantity,
          price: price,
        });
      }
    },
    handleCellClick(doctor, date) {
      const _this = this;
      _this.DoctorAppointment.GetDoctorAppointmentScheduleListByDate(
        doctor.id,
        date,
        function (data) {
          const [year, month] = _this.searchForm.datepicker.split("-");
          let dateMonth = `${year}${month}` * 1;
          const schedule = data.data;
          _this.tempSchedule = {
            doctorId: doctor.id,
            doctorName: doctor.userName,
            doctorPhone: doctor.phone,
            scheduleMode: doctor.scheduleMode,
            appointmentDetailList: null,
            dateMonth: dateMonth,
            doctor: doctor,
            date: date,
            timeArray: [],
            dataTag: {
              am: false,
              amQuantity: 0,
              amPrice: 0,
              pm: false,
              pmQuantity: 0,
              pmPrice: 0,
            },
            mark: "edit",
          };
          if (schedule && schedule.length > 0) {
            _this.initTimeArray(schedule);
          } else {
            _this.initTimeArray();
            _this.tempSchedule.mark = "add";
          }
          _this.dialogTitle = `${doctor.userName} - ${_this.formatFullDate(date)} - ${_this.formatWeekday(date)}`;
          _this.dialogVisible = true;
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    delSchedule(doctor, date) {
      this.$confirm(`确定删除【${date}】【${this.formatWeekday(date)}】排班?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const _this = this;
          _this.DoctorAppointment.DeleteDoctorAppointmentSchedule(
            doctor.id,
            date,
            function (data) {
              _this.$message.success("排班设置已删除");
              _this.allDoctors = [];
              _this.loadDoctors();
            },
            function (err) {
              var jsonObj = JSON.parse(err.msg);
              if (jsonObj.code == "400") {
                _this.$message({
                  type: "error",
                  message: jsonObj.msg,
                });
              }
            }
          );
        })
        .catch(() => {});
    },
    handelChange(e, index) {
      if (!e) {
        this.tempSchedule.timeArray[index].quantity = null;
        this.tempSchedule.timeArray[index].price = null;
        return;
      }
    },
    saveSchedule() {
      var _this = this;
      let array = this.tempSchedule.timeArray.filter((i) => i.isHave == true);
      if (array.length == 0) {
        _this.$message({
          type: "warning",
          message: "请至少选择一个时间段！",
        });
        return;
      }
      for (let index = 0; index < this.tempSchedule.timeArray.length; index++) {
        const element = this.tempSchedule.timeArray[index];
        if (element.isHave) {
          if (element.quantity <= 0) {
            _this.$message({
              type: "warning",
              message: `请设置${element.startTime} ~ ${element.endTime}放号数量！`,
            });
            return;
          }
          if (element.price <= 0) {
            _this.$message({
              type: "warning",
              message: `请设置${element.startTime} ~ ${element.endTime}放号金额！`,
            });
            return;
          }
        }
      }
      let appointmentDetailList = [];
      for (let index = 0; index < this.tempSchedule.timeArray.length; index++) {
        const element = this.tempSchedule.timeArray[index];
        if (element.isHave) {
          if (this.tempSchedule.mark == "add") {
            appointmentDetailList.push({
              weekDay: this.tempSchedule.scheduleMode == 1 ? this.formatWeekdayNum(this.tempSchedule.date) : -1,
              scheduleDate: this.tempSchedule.scheduleMode == 0 ? this.tempSchedule.date : null,
              timePeriod: element.timePeriod,
              startTime: element.startTime,
              endTime: element.endTime,
              quantity: element.quantity,
              price: element.price,
            });
          } else {
            appointmentDetailList.push({
              scheduleDate: this.tempSchedule.date,
              timePeriod: element.timePeriod,
              startTime: element.startTime,
              endTime: element.endTime,
              quantity: element.quantity,
              price: element.price,
            });
          }
        }
      }
      let subData = {
        doctorId: this.tempSchedule.doctorId,
        doctorName: this.tempSchedule.doctorName,
        doctorPhone: this.tempSchedule.doctorPhone,
        dateMonth: this.tempSchedule.dateMonth,
        scheduleMode: this.tempSchedule.scheduleMode,
        appointmentDetailList: appointmentDetailList,
      };
      if (this.tempSchedule.mark == "add") {
        _this.DoctorAppointment.SubmitDoctorAppointmentSchedule(
          subData,
          function (data) {
            _this.dialogVisible = false;
            _this.$message.success("排班设置已保存");
            _this.pageIndex = 1;
            _this.allDoctors = [];
            _this.loadDoctors();
          },
          function (err) {
            var jsonObj = JSON.parse(err.msg);
            if (jsonObj.code == "400") {
              _this.$message({
                type: "error",
                message: jsonObj.msg,
              });
            }
          }
        );
      } else {
        _this.DoctorAppointment.UpdateDoctorAppointmentSchedule(
          subData.doctorId,
          subData.appointmentDetailList,
          function (data) {
            _this.dialogVisible = false;
            _this.$message.success("排班设置已保存");
            _this.pageIndex = 1;
            _this.allDoctors = [];
            _this.loadDoctors();
          },
          function (err) {
            var jsonObj = JSON.parse(err.msg);
            if (jsonObj.code == "400") {
              _this.$message({
                type: "error",
                message: jsonObj.msg,
              });
            }
          }
        );
      }
    },
    saveSchedules() {
      // 实际项目中这里应该调用API保存数据
      console.log("保存的排班数据:", this.allDoctors);
      this.$message.success("排班数据已保存");
    },
    // 滚动联动处理
    handleFixedScroll(e) {
      if (!this.scrollSync) return;

      const scrollTop = e.target.scrollTop;
      const scrollableContent = this.$refs.scrollableContent;
      if (scrollableContent) {
        this.scrollSync = false;
        scrollableContent.scrollTop = scrollTop;
        this.$nextTick(() => {
          this.scrollSync = true;
        });
      }

      // 检查是否滚动到底部，触发加载更多
      const { scrollHeight, clientHeight, scrollTop: currentScrollTop } = e.target;
      if (scrollHeight - (clientHeight + currentScrollTop) < 50 && !this.loading && this.visibleDoctors.length < this.allDoctors.length) {
        this.loadMore();
      }
    },
    handleContentScroll(e) {
      if (!this.scrollSync) return;

      const scrollTop = e.target.scrollTop;
      const fixedColumn = this.$refs.fixedColumn;
      if (fixedColumn) {
        this.scrollSync = false;
        fixedColumn.scrollTop = scrollTop;
        this.$nextTick(() => {
          this.scrollSync = true;
        });
      }

      // 检查是否滚动到底部，触发加载更多
      const { scrollHeight, clientHeight, scrollTop: currentScrollTop } = e.target;
      if (scrollHeight - (clientHeight + currentScrollTop) < 50 && !this.loading && this.visibleDoctors.length < this.allDoctors.length) {
        this.loadMore();
      }
    },
    loadMore() {
      this.PageIndex += 1;
      this.updateVisibleDoctors();

      // 如果已加载的数据不足，继续加载更多
      if (this.visibleDoctors.length >= this.allDoctors.length) {
        this.loadDoctors();
      }
    },
    // 拖拽滚动处理
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.pageX - this.$refs.scrollableContent.offsetLeft;
      this.scrollLeft = this.$refs.scrollableContent.scrollLeft;
      this.$refs.scrollableContent.style.cursor = "grabbing";
      this.$refs.scrollableContent.style.userSelect = "none";
    },
    handleDrag(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.pageX - this.$refs.scrollableContent.offsetLeft;
      const walk = (x - this.startX) * 2; // 调整拖拽灵敏度
      this.$refs.scrollableContent.scrollLeft = this.scrollLeft - walk;
    },
    endDrag() {
      this.isDragging = false;
      this.$refs.scrollableContent.style.cursor = "grab";
      this.$refs.scrollableContent.style.removeProperty("user-select");
    },
  },
};
</script>
<style scoped>
.ParameterForm .el-input {
  margin-right: 10px;
  width: 150px;
  vertical-align: top;
}
.bg1 {
  width: 8px;
  height: 8px;
  background: #e58225;
  border-radius: 4px;
  margin: 0 10px;
}
.bg2 {
  width: 8px;
  height: 8px;
  background: #5c955c;
  border-radius: 4px;
  margin: 0 10px;
}
</style>
<style scoped>
.schedule-container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.toolbar {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  align-items: center;
}

.table-wrapper {
  height: calc(100% - 50px);
  display: flex;
  flex: 1;
  overflow: hidden;
  border: 5px solid #ebeef5;
  border-radius: 4px;
  position: relative;
}

.fixed-column {
  max-width: 140px;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid #ebeef5;
  background: white;
  position: sticky;
  left: 0;
  z-index: 2;
}
.scrollable-hidden {
  padding-bottom: 20px; /* 给内容留出空间 */
  margin-bottom: -20px; /* 抵消padding */
}

.scrollable-hidden::-webkit-scrollbar {
  display: none;
}
.scrollable-content {
  flex: 1;
  overflow: auto;
  cursor: grab;
}

.scrollable-content:active {
  cursor: grabbing;
}

table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  border: 2px solid #ebeef5;
  padding: 8px;
  text-align: center;
}

.fixed-header {
  /* background: #f5f7fa; */
  background: white;
  font-weight: bold;
  padding: 20px 12px;
  text-align: center;
  position: sticky;
  top: 0;
  z-index: 3;
}

.fixed-cell {
  background: white;
  position: sticky;
  left: 0;
  z-index: 1;
  height: 110px;
  overflow: hidden;
  padding: 0;
}
/* .doctor-info {
  gap: 6px;
} */
.note-logo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.doctor-name {
  font-size: 12px;
  width: 120px;
  padding: 0 5px;
}

.doctor-details {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: center;
}

.doctor-status {
  margin-top: 4px;
}

.day-header {
  min-width: 100px;
  padding: 8px 4px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
}

.day-header div:first-child {
  font-size: 21px;
  color: #333;
  font-weight: bold;
}

.day-header div:last-child {
  font-size: 10px;
  line-height: 1;
  /* color: #666; */
}

.day-cell {
  min-width: 170px;
  height: 110px;
  padding: 0;
  cursor: pointer;
}
.cell-content {
  width: 100%;
  height: 100%;
  align-items: start !important;
  padding: 8px 0 5px;
}
.t1 {
  width: 90%;
  margin: 0 auto;
  border-radius: 2px;
  font-size: 12px;
  padding: 0 4px 0 0;
}
.t2 {
  margin: 0 5px;
  font-size: 12px;
  font-weight: bold;
}
.t3 {
  width: 86%;
  margin: 0 auto;
  font-size: 12px;
  color: #cccccc;
}
.line1 {
  width: 2px;
  height: 22px;
  border-radius: 2px 0 0 2px;
  background: #cccccc;
}
.schedule-available {
  /* background-color: #f0f9eb; */
  color: #67c23a;
}

.schedule-partial {
  background-color: #fdf6ec;
  color: #e6a23c;
}

.schedule-full {
  background-color: #fef0f0;
  color: #f56c6c;
}

.schedule-disabled {
  background-color: #fcfcfc;
  color: #cccccc;
}
.schedule-disabled .desc-disabled {
  background: #f6f6f6;
  border: 1px solid #f0f0f0;
  color: #cccccc;
}
.schedule-available .desc-available2 {
  background: #f1f8f4;
  border-radius: 2px;
  border: 1px solid #e8f4ed;
  color: #5c955c;
}
.schedule-available .desc-available1 {
  background: #fff0e0;
  border-radius: 2px;
  border: 1px solid #ffedd9;
  color: #e58225;
}
.schedule-available .line2 {
  width: 2px;
  height: 22px;
  border-radius: 2px 0 0 2px;
  background: #e58225;
}
.schedule-available .line3 {
  width: 2px;
  height: 22px;
  border-radius: 2px 0 0 2px;
  background: #5c955c;
}
.loading-cell {
  text-align: center;
  padding: 16px;
  color: #999;
}

.schedule-remain {
  margin-left: 8px;
  font-size: 12px;
  color: #666;
}

.el-icon.is-loading {
  margin-right: 6px;
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
